import useSWRInfinite from 'swr/infinite';

import fetcher from 'lib/fetcher';
import { ITEMS_PER_PAGE } from 'lib/constants';

const useFilterPaginatedData = <R, I>(
  url: string,
  method: 'get' | 'post',
  transform?: (res: R) => { notification: I[]; count: number; createdAtSortDirection: string },
  payload?: object,
) => {
  const { data, size, isLoading, ...rest } = useSWRInfinite(
    (pageIndex) => [url, pageIndex, payload],
    ([url, pageIndex, payload]) => {
      const pagination = { page: pageIndex + 1, count: ITEMS_PER_PAGE };

      return fetcher
        .swr<R>(url, {
          method,
          params: method === 'get' ? pagination : undefined,
          data:
            method === 'post'
              ? { ...{ ...payload, createdAtSortDirection: 'DESC' }, ...pagination }
              : undefined,
        })
        .then(transform);
    },
    { revalidateFirstPage: true, keepPreviousData: false, revalidateOnMount: true },
  );

  let total = 0;
  let result = [] as I[];
  if (data) {
    result = data.flatMap((d) => d.notification);
    total = data[0].count;
  }

  const isLoadingMore = isLoading || (size > 0 && !!data && typeof data[size - 1] === 'undefined');

  return { data: result, total, isInitialLoading: isLoading, isLoadingMore, ...rest };
};

export default useFilterPaginatedData;
